import { IssueFront, RowModel, Page, DatatableMessage } from '../../models/api.models';

export class IssueData {
    issuesFront: IssueFront[];
    page: Page;
    idsFilterIssues: number[];
    loading: boolean;
    msg: DatatableMessage;
    selected: IssueFront[];
    rowsModelDataToUpdate: RowModel[];
}
